module.exports = __webpack_public_path__ + "img/icons-send-text.cd297d0e.svg";